import * as types from '../actions/actionTypes';
import initialState from "./initialState";


export function navigationReducer(
  state = initialState.navigation, action
  ) {
  switch(action.type) {
    case types.UPDATE_HAMBURGER_MENU_STATUS:
      return {
        ...state,
        hamburgerMenu: action.status
      }
      case types.UPDATE_THEME:
        return {
          ...state,
          theme: action.theme
        }
    default:
      return state;
  }
}




// WEBPACK FOOTER //
// ./src/redux/reducers/navigationReducer.js